export const FACEBOOK_LINK = 'https://www.facebook.com/jidlonatrek';
export const INSTAGRAM_LINK = 'https://www.instagram.com/jidlonatrek/?fbclid=IwAR0OEYy0UGKkxYmWGwdy3dQpkCTszQlDN7rFMaqbi5uu6i0FlurAEjOoVTQ';
